/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Headings_MainInputs */

const id_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi`)
};

const ms_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi`)
};

const da_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger`)
};

const de_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlungen`)
};

const en_us2_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const es_es2_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones`)
};

const es_mx2_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones`)
};

const fil_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Koleksyon`)
};

const fr_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const it_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezioni`)
};

const hu_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyűjtemények`)
};

const nl_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecties`)
};

const no_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger`)
};

const pl_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekcje`)
};

const pt_br2_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções`)
};

const pt_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções`)
};

const ro_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecții`)
};

const fi_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmat`)
};

const sv_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingar`)
};

const vi_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ sưu tập`)
};

const tr_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyonlar`)
};

const cs_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekce`)
};

const bg_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекции`)
};

const ru_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборки`)
};

const uk_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекції`)
};

const ar_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعات`)
};

const hi_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कलेक्शन`)
};

const th_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอลเล็กชัน`)
};

const ja_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクション`)
};

const zh_cn2_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集`)
};

const zh_hant1_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集`)
};

const ko_collections_headings_main = /** @type {(inputs: Collections_Headings_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉션`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Collections_Headings_MainInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_headings_main = /** @type {((inputs?: Collections_Headings_MainInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Headings_MainInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_headings_main(inputs)
	if (locale === "ms") return ms_collections_headings_main(inputs)
	if (locale === "da") return da_collections_headings_main(inputs)
	if (locale === "de") return de_collections_headings_main(inputs)
	if (locale === "en-US") return en_us2_collections_headings_main(inputs)
	if (locale === "es-ES") return es_es2_collections_headings_main(inputs)
	if (locale === "es-MX") return es_mx2_collections_headings_main(inputs)
	if (locale === "fil") return fil_collections_headings_main(inputs)
	if (locale === "fr") return fr_collections_headings_main(inputs)
	if (locale === "it") return it_collections_headings_main(inputs)
	if (locale === "hu") return hu_collections_headings_main(inputs)
	if (locale === "nl") return nl_collections_headings_main(inputs)
	if (locale === "no") return no_collections_headings_main(inputs)
	if (locale === "pl") return pl_collections_headings_main(inputs)
	if (locale === "pt-BR") return pt_br2_collections_headings_main(inputs)
	if (locale === "pt") return pt_collections_headings_main(inputs)
	if (locale === "ro") return ro_collections_headings_main(inputs)
	if (locale === "fi") return fi_collections_headings_main(inputs)
	if (locale === "sv") return sv_collections_headings_main(inputs)
	if (locale === "vi") return vi_collections_headings_main(inputs)
	if (locale === "tr") return tr_collections_headings_main(inputs)
	if (locale === "cs") return cs_collections_headings_main(inputs)
	if (locale === "bg") return bg_collections_headings_main(inputs)
	if (locale === "ru") return ru_collections_headings_main(inputs)
	if (locale === "uk") return uk_collections_headings_main(inputs)
	if (locale === "ar") return ar_collections_headings_main(inputs)
	if (locale === "hi") return hi_collections_headings_main(inputs)
	if (locale === "th") return th_collections_headings_main(inputs)
	if (locale === "ja") return ja_collections_headings_main(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_headings_main(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_headings_main(inputs)
	return ko_collections_headings_main(inputs)
});
export { collections_headings_main as "collections.headings.main" }